import { render, staticRenderFns } from "./ListModelosPecas.vue?vue&type=template&id=2fa3ed89&"
import script from "./ListModelosPecas.vue?vue&type=script&lang=js&"
export * from "./ListModelosPecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports